<template>
    <div class="bng-page-container" :class="{'extended':theme=='dark'}">
        <jackpot-win v-if="showBars" />
            <topbar-1 v-if="theme != 'luckerhub' && theme != 'cashcasino'" @changeOpeningMobileMenu="changeOpeningMobileMenu"/>
            <topbar-2 v-else @changeOpeningMobileMenu="changeOpeningMobileMenu"/>
        <div class="bng-main-content">
            <div v-if="showTelegramLink" class="bng-telegram-link has-text-centered">
                <a
                    class="button is-info"
                    :class="{'is-big': isMobile, 'is-large': !isMobile}"
                    :href="telegramLink"
                    target="_blank"
                >
                    <span class="icon">
                        <i class="fab fa-telegram"></i>
                    </span>
                    <span v-if="client.view.general.alias && client.view.general.alias.toLowerCase() === 'slotssofts'">{{"components.pages.sitepages-layout.slotssofts play in telegram" | translate}}</span>
                    <span v-else>{{"components.pages.sitepages-layout.play in telegram" | translate}}</span>
                </a>
            </div>
            <router-view />
        </div>
        <basement v-if="showBars" :isOpenMobileMenu="isOpenMobileMenu"/>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import JackpotWin from '../../common/jackpots/jackpot-win/jackpot-win.vue';
import Topbar1 from '../../common/topbar/topbar-1.vue';
import Topbar2 from '../../common/topbar/topbar-2.vue';
import Basement from '../../common/basement/basement.vue';

export default {
    name: 'site-pages-layout',
    components: { JackpotWin, Topbar1, Basement, Topbar2 },
    data() {
        return {
            isMobile: isMobile.phone || isMobile.tablet,
            showTelegramLink: false,
            telegramLink: null,
            theme: null,
            isOpenMobileMenu: false
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        showBars() {
            return this.isLoggedIn || (this.client && !this.client.view.auth.authenticationHideBars);
        },
    },
    watch: {
        isLoggedIn() {
            this.refreshTelegramLink();
        }
    },
    async created() {
        await Vue.state.client.ensure();
        this.refreshTelegramLink();
        this.theme = (this.client && this.client.view && this.client.view.style.theme) || 'dark';
    },
    methods: {
        refreshTelegramLink() {
            this.telegramLink = this.client.view.bot.telegramLink;
            let telegramLinkVisibleFor = this.client.view.bot.telegramLinkVisibleFor;
            this.showTelegramLink =
                this.telegramLink &&
                (telegramLinkVisibleFor == 'all' ||
                (telegramLinkVisibleFor == 'authorized' && this.isLoggedIn) ||
                (telegramLinkVisibleFor == 'unauthorized' && !this.isLoggedIn));
        },
        changeOpeningMobileMenu({ isOpen }) {
            this.isOpenMobileMenu = isOpen;
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/sitepages-layout.vue